module.exports = __webpack_public_path__ + "media/images/sendgrid-bcf966ffe25f4bd627cbf0daa0c32e53.svg";